<template>
  <g>
    <g 
      v-for="spot in centerSpots"
      :key="spot.id">
      <visualization-contour-spot
        :spot="spot"
        :layer-type="'humidity'"
      />
    </g>
  
    <!-- NOTE: Image mask for thing -->
    <map-mask-image />

    <!-- NOTE: Contour spot for thing -->
    <g 
      v-for="spot in individualSpots"
      :key="spot.id">
      <visualization-contour-spot
        :spot="spot"
        :layer-type="'humidity'"
      />
    </g>
  </g>
</template>

<script>
import config from '@/config.js';
import map from '@/mixins/map.js';
import mapMaskImage from '@/components/map/map_mask_image.vue';
import visualizationContour from '@/components/map/visualization/partials/contours.vue';
import visualizationContourSpot from '@/components/map/visualization/partials/contours_spot.vue';

export default {
  components: {
    mapMaskImage,
    visualizationContour,
    visualizationContourSpot,
  },
  mixins: [map],
  computed: {
    spots: ({ $store }) => $store.getters['area/spotAll'],
    humiditySpots: (vm) => vm.spots.filter((spot) => vm.isPrivateSpot(spot)),
    centerSpots: (vm) => vm.humiditySpots.filter((spot) => vm.isCenterSpot(spot.tags || [])),
    individualSpots: (vm) => vm.humiditySpots.filter((spot) => vm.isIndividualSpot(spot.tags || [])),
    humidityVisualizationConfig:() => config.visualizationHeaders['humidity'],
    humidityMinValue: (vm) => vm.humidityVisualizationConfig.minValue,
    humidityMaxValue: (vm) => vm.humidityVisualizationConfig.maxValue,
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getHumidityThings();
      this.$store.commit('visualization/setMinValue', { layerType: 'humidity', value: this.humidityMinValue });
      this.$store.commit('visualization/setMaxValue', { layerType: 'humidity', value: this.humidityMaxValue });
      this.$store.commit('visualization/setLineInterval', { layerType: 'humidity', value: 5 });
    },
    async getHumidityThings() {
      await this.$store.dispatch('visualization/getHumidityThings');
    },
  },
};
</script>



// WEBPACK FOOTER //
// humidity.vue?07609c6c